import logger from '@eventbrite/client-logger';
import { checkGate } from '@eventbrite/statsig';
import {
    GOOGLE_PAY_MERCHANT_NAME,
    GOOGLE_PAY_SHARED_PAYLOAD,
} from '../constants/googlePay';
import { getCurrency } from '../selectors/event';
import { getTotalAmount } from '../selectors/order';
import { CheckoutState } from '../state';

export const canMakePaymentsWithGooglePay = (isProd: boolean) => {
    const environment = isProd ? 'PRODUCTION' : 'TEST';

    return new google.payments.api.PaymentsClient({
        environment,
    }).isReadyToPay(GOOGLE_PAY_SHARED_PAYLOAD);
};

export const isGooglePayIntegrationSupportedInNativeApp = () =>
    window.android?.isGooglePayIntegrationSupported?.();

export const isReadyToPayInAndroidApp = (
    successCallback: () => void,
    errorCallback: (error: any) => void,
) => {
    window._isReadyToPaySuccessCallback = successCallback;
    window._isReadyToPayErrorCallback = errorCallback;

    try {
        window.android.isReadyToPay(
            true,
            '((isReady) => {' +
                '    window._isReadyToPaySuccessCallback(isReady);' +
                '    delete window._isReadyToPaySuccessCallback;' +
                '})',
            '((errorMessage) => {' +
                '    window._isReadyToPayErrorCallback(errorMessage);' +
                '    delete window._isReadyToPayErrorCallback;' +
                '})',
        );
    } catch (e) {
        logger.error(e);
    }
};

export const makePaymentInAndroidApp = (
    state: CheckoutState,
    successCallback: (googlePayBraintreeNonce: string) => void,
    errorCallback: (error: any) => void,
) => {
    window._makePaymentSuccessCallback = successCallback;
    window._makePaymentErrorCallback = errorCallback;

    try {
        window.android.makePayment(
            `${getTotalAmount(state)}`,
            getCurrency(state) || 'USD',
            GOOGLE_PAY_MERCHANT_NAME,
            '((googlePayBraintreeNonce) => {' +
                '    window._makePaymentSuccessCallback(googlePayBraintreeNonce);' +
                '    delete window._makePaymentSuccessCallback;' +
                '})',
            '((errorMessage) => {' +
                '    window._makePaymentErrorCallback(errorMessage);' +
                '    delete window._makePaymentErrorCallback;' +
                '})',
        );
    } catch (e) {
        logger.error(e);
    }
};

export const checkGooglePayFeatureGateIfReady = (
    canMakePaymentsWithGooglePay: boolean,
) =>
    !!canMakePaymentsWithGooglePay &&
    checkGate('google_pay_eligibility_checkout');
